module.exports = __webpack_public_path__ + "static/media/OpenIcon.32efc1d3.svg";